<template>
  <v-text-field
    :id="id"
    v-model.number="text"
    dense
    outlined
    hide-details
    required
    @keydown="validateInput($event)"
    :disabled="disabled"
    @blur="onBlur"
    :maxLength="maxLength"
    :suffix="suffix"
  ></v-text-field>
</template>

<script>
import RepeatTypeSelect from "./RepeatTypeSelect.vue";
export default {
  components: { RepeatTypeSelect },
  props: {
    value: {
      type: [Number, String],
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: 999,
    },
    suffix: {
      type: String,
      default: undefined,
    },
    maxLength: {
      type: Number,
      default: 3,
    },
    id: String,
  },
  mounted() {
    const numberInput = document.getElementById(this.id);

    // Add an event listener for the "contextmenu" event (right-click)
    // numberInput.addEventListener("contextmenu", function (e) {
    //   // Prevent the default context menu from appearing
    //   // e.preventDefault();
    // });
    numberInput.addEventListener("paste", function (e) {
      // Get the text being pasted
      const clipboardData = e.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData("text");
      // Check if the pasted text is a valid number
      if (!/^\d+$/.test(pastedText)) {
        // If it's not a valid number, prevent the default paste behavior
        e.preventDefault();
      }
    });
  },
  computed: {
    text: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    onBlur,
    validateInput,
    isWithinRange,
  },
};

function isNumeric(charCode) {
  return (
    (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)
  );
}

function isValidKey(key) {
  return key !== "." && key !== "e" && key !== "-";
}

function isWithinRange(value, min, max) {
  return value >= min && value <= max;
}

function validateInput(event) {
  const key = event.key;
  const charCode = event.which || event.keyCode;
  const input = event.target;
  const inputValue = input.value + key;

  if (!(event.ctrlKey || event.metaKey) || event.key !== "v") {
    if (
      !(
        isNumeric(charCode) ||
        charCode === 8 ||
        charCode === 9 ||
        charCode === 17
      ) ||
      (inputValue.length > 0 && inputValue[0] === "0") ||
      isInputInvalid(inputValue, key, charCode, this.max)
    ) {
      event.preventDefault();
    }
  }

  // need this code for backup

  // if ((event.ctrlKey || event.metaKey) && event.key === "v") {
  // } else {
  //   if (
  //     !isNumeric(charCode) &&
  //     charCode !== 8 &&
  //     charCode !== 9 &&
  //     charCode !== 17
  //   ) {
  //     return event.preventDefault();
  //   }

  //   if (inputValue.length > 0 && inputValue[0] === "0") {
  //     return event.preventDefault();
  //   }

  //   if (isInputInvalid(inputValue, key, charCode, this.max)) {
  //     return event.preventDefault();
  //   }
  // }
  // backup code
}

function isInputInvalid(inputValue, key, charCode, max) {
  return !!(
    !isValidKey(key) ||
    (max === 31 &&
      !isWithinRange(parseInt(inputValue, 10), 1, 31) &&
      charCode !== 9 &&
      charCode !== 8 &&
      charCode !== 17) ||
    String(inputValue).length > max
  );
}

function onBlur() {
  const pasteValue = String(this.text).replace(/[^0-9]/g, "");
  if (String(this.text) === "") {
    this.$emit("input", 1);
  } else {
    if (this.max === 31 && !isWithinRange(parseInt(pasteValue, 10), 1, 31)) {
      this.$emit("input", 1);
    }
  }
}
</script>

<style>
</style>